import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/app/context";
import ZoneTypeContext from "../../../context/wms/zone-type/context";
import ZoneTypeContextProvider from "../../../context/wms/zone-type/provider";
import { useIsMount } from "../../../utils/hooks/is-mount";
import ZoneTypeTable from "../../../components/wms/zone-type/zone-type-table";
import SearchFilterCard from "../../../components/general/filter-card";
import Can from "../../../utils/rbac/can";
import PageHeader from "../../../components/general/layout/page-header";
import RefreshBtn from "../../../components/general/table-components/actions/refresh-btn";
import { Permissions } from "../../../utils/Permissions/Permissions";
import ZoneTypeFilter from "../../../components/wms/zone-type/zone-type-filter";
import styles from "./style.module.scss";

interface IProps {
  children?: React.ReactNode;
}

const ZoneTypeComponent: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(ZoneTypeContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("zone_types")}
        subTitle={t("zone_types_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Can key={2} perform={Permissions.CAN_VIEW_ALL_WMS_ZONE_TYPES}>
            <Divider key={1} type="vertical" />
            <Button
              type="primary"
              onClick={() => {
                navigate(`/wms/zone-types/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_zone_type")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="zone-type-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <ZoneTypeFilter />
      </SearchFilterCard>

      <ZoneTypeTable />
    </div>
  );
};

const ZoneTypePage = () => {
  return (
    <ZoneTypeContextProvider>
      <ZoneTypeComponent />
    </ZoneTypeContextProvider>
  );
};

export default ZoneTypePage;
